/* eslint-disable import/prefer-default-export */
export const eligibilityReviewReportConfig = {
  agentName: "Eligibility Review Agent",
  title: "Eligibility Review Report",
  subtitle: "Eligibility Review Agent",
  backPath: "/eligibility-review-agent",
};
